import React from 'react';

import { Link } from 'react-router-dom';

import ReduxConnect from 'Demora/redux-connect';

import alert from 'Demora/modals/alert';

import incompatible_browser from './utils/incompatible_browser';

class LinkOrA extends React.Component {
	constructor() {
		super();

		this.state = {
			clicked: false,
			to: null,
			//			children: null,
		};
	}

	static getDerivedStateFromProps(props, state) {
		if (state.to != props.to) {
			// || state.children != props.children) {
			return {
				clicked: false,
				to: props.to,
				//				children: props.children,
			};
		}

		return null;
	}

	clicked = (e) => {
		let props = this.props;

		if (props.countdown > 0) {
			e.preventDefault();

			this.props.dispatch({
				type: 'SET_SURFBAR_COUNTDOWN_TIMER',
				countdown: 10,
			});

			alert(
				'surfbar_click_too_fast',
				'Warning',
				'You need to wait until the counter reaches 0 before clicking on the next ad.'
			);
			return;
		}

		if (this.state.clicked) {
			e.preventDefault();
		}

		if (e.type == 'keydown' && props.onKeyDown) {
			props.onKeyDown(e);
		} else if (e.type == 'mousedown' && props.onMouseDown) {
			props.onMouseDown(e);
		} else if (e.type == 'click') {
			this.setState({
				clicked: true,
			});
			if (props.onClick) {
				props.onClick(e);
			}
		}
	};

	render() {
		let props = this.props;

		if (this.state.clicked) {
			return (
				<span className={props.className} style={props.style}>
					{props.children}
				</span>
			);
		} else if (incompatible_browser()) {
			return (
				<a
					href={props.to}
					onKeyDown={this.clicked}
					onMouseDown={this.clicked}
					onClick={this.clicked}
					className={props.className}
					style={props.style}
					rel={props.rel}
				>
					{props.children}
				</a>
			);
		} else {
			return (
				<Link
					to={props.to}
					onKeyDown={this.clicked}
					onMouseDown={this.clicked}
					onClick={this.clicked}
					className={props.className}
					style={props.style}
					rel={props.rel}
				>
					{props.children}
				</Link>
			);
		}
	}
}

export default ReduxConnect(LinkOrA, {
	countdown: 'countdown',
});
